import { NgModule } from '@angular/core';
import { SavedZeitenFiltersComponentModule, ZeitenFilterComponentModule, ZeitenListComponentModule, ZeitenSorterComponentModule } from '.';

@NgModule({
  imports: [ZeitenFilterComponentModule, ZeitenListComponentModule, ZeitenSorterComponentModule, SavedZeitenFiltersComponentModule],
  exports: [ZeitenFilterComponentModule, ZeitenListComponentModule, ZeitenSorterComponentModule, SavedZeitenFiltersComponentModule],
})
export class ZeitenQueryModule {}
